<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>New Product</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <div class="text-secondary text-uppercase mt-3 mb-1">Name</div>
        <d-input v-model="name" help="hi" :state="validName ? null: false" class="mb-2" />
        <small v-if="!validName">A name is required</small>

        <div class="text-secondary text-uppercase mt-3 mb-1">
          Description
        </div>
        <quill-editor
          ref="myQuillEditor"
          v-model="description"
          :options="quillOptions"
        />
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose"
          >Cancel</d-button
        >
        <async-button
          @click="insertProduct"
          text="Continue"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import quillDefaultOptions from "@/utils/quillOptions";

export default {
  data() {
    return {
      name: "",
      description: "",
      id: null,
      quillOptions: quillDefaultOptions,
      saving: false,
      validName: true,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    quillEditor,
  },
  watch: {
    showModal() {
      this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.name = "";
      this.description = "";
      this.saving = false;
    },
    onEditorChange({ quill, html, text }) {
      this.description = html;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    validateName() {
      this.validName = (3 < this.name.length && this.name.length < 100);
    },
    validate() {
      this.validateName();
      return this.validName;
    },
    insertProduct() {
      if (this.validate()) {
        this.saving = true;
        const product = {
          name: this.name,
          description: this.description,
        };
        this.$store
          .dispatch("products/insert", product)
          .then((result) => {
            this.saving = false;
            this.$router.push({ name: "products__edit", params: { key: result.key } });
            this.handleClose();
          });
      }
    },
  },
};
</script>

<style></style>
